import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../../data/products";

export const ProductsShowcase = () => {
  return (
    <section data-testid="products-showcase" className="relative bg-[#FFFFFF] py-24 md:py-32 border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="eyebrow mb-4">// Our Systems · 01</div>
            <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[0.95] max-w-3xl">
              Engineered for the<br />
              <span className="text-[#0EA5E9]">world's hardest jobs</span>
            </h2>
          </div>
          <Link
            to="/products"
            data-testid="products-view-all"
            className="group inline-flex items-center gap-3 text-sm uppercase tracking-[0.2em] text-[#475569] hover:text-slate-900"
          >
            View All Systems
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
            >
              <Link
                to={`/products/${p.slug}`}
                data-testid={`product-card-${p.slug}`}
                className="product-card group block bg-[#FFFFFF] hover:bg-[#F8FAFC] p-6 h-full transition-colors"
              >
                <div className="aspect-[4/3] overflow-hidden bg-[#F8FAFC] border border-[#E2E8F0] group-hover:border-[#0EA5E9] transition-colors mb-6">
                  <img src={p.image} alt={p.name} className="product-img w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex items-center justify-between mb-3">
                  <span className="font-mono-wm text-[10px] tracking-[0.3em] uppercase text-[#0EA5E9]">
                    SYS / {String(i + 1).padStart(2, "0")}
                  </span>
                  <ArrowUpRight className="w-4 h-4 text-[#64748B] group-hover:text-[#0EA5E9] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
                <h3 className="font-display text-xl md:text-2xl text-slate-900 uppercase tracking-tight leading-tight">{p.name}</h3>
                <p className="mt-3 text-sm text-[#475569] leading-relaxed">{p.tagline}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsShowcase;
